import { RouteInfo } from './sidebar.metadata';
import { HelperService } from '@shared/services/helper.service';
const helperService = new HelperService();
// Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [

    {
        path: '', title: 'Dashboard', icon: 'zmdi zmdi-home', class: 'sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
                path: (helperService.getUserType() === 'CUSTOMER') ? '/dashboard/landing' : '/dashboard/home',
                title: 'Home',
                icon: 'fa fa-dot-circle-o',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: [],
                accessPermission: ['get_customer', 'CUSTOMER','create_installation'],
                childpath: ''
            },
            // {
            //     path: '/dashboard/graphic',
            //     title: 'Graphic View',
            //     icon: 'fa fa-dot-circle-o',
            //     class: '',
            //     badge: '',
            //     badgeClass: '',
            //     isExternalLink: false,
            //     submenu: [],
            //     accessPermission: ['create_installation', 'CUSTOMER','create_installation'],
            //     childpath: ''
            // },
            {
                path: '/scanfilter/qcscans',
                title: 'QC Scans',
                icon: 'fa fa-dot-circle-o',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: [],
                accessPermission: ['create_installation', 'CUSTOMER','create_installation'],
                childpath: ''
            },
        ],
        accessPermission: ['customer_admin1', 'get_customer1', 'CUSTOMER1','create_installation'],
        childpath: (helperService.getUserType() === 'CUSTOMER') ? '/dashboard/landing' : '/dashboard/home'
    },
    {
        path: '', title: 'Customer Management', icon: 'zmdi zmdi-account', class: 'sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
                path: '/superadmin/customers',
                title: 'All Customers',
                icon: 'fa fa-dot-circle-o',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: [],
                accessPermission: ['get_customer'],
                childpath: ''
            },
            {
                path: '/superadmin/onboard',
                title: 'Onboard Customer',
                icon: 'fa fa-dot-circle-o',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: [],
                accessPermission: ['get_customer'],
                childpath: ''
            }
        ],
        accessPermission: ['create_customer'],
        //deninedPermission: ['get_admin'],
        childpath: ''
    },
    {
        path: '', title: 'Config Management', icon: 'zmdi zmdi-settings-square', class: 'sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            // {
            //     path: '/superadmin/reporting',
            //     title: 'Reporting',
            //     icon: 'fa fa-dot-circle-o',
            //     class: '',
            //     badge: '',
            //     badgeClass: '',
            //     isExternalLink: false,
            //     submenu: [],
            //     accessPermission: ['get_customer'],
            //     childpath: ''
            // },
            {
                path: '/superadmin/masterconfig',
                title: 'Master Configuration',
                icon: 'fa fa-dot-circle-o',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: [],
                accessPermission: ['get_customer'],
                childpath: ''
            },
        ],
        accessPermission: ['create_customer'],        
        childpath: ''
    },
    {
        path: '', title: 'Partner Customers', icon: 'zmdi zmdi-account', class: 'sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
                path: '/partner/customers',
                title: 'List',
                icon: 'fa fa-dot-circle-o',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: [],
                accessPermission: ['approve_customer'],
                childpath: ''
            },
        ],
        accessPermission: ['approve_customer'],
        deninedPermission: ['get_admin'],
        childpath: ''
    },
    {
        path: '', title: 'Analysis List', icon: 'zmdi zmdi-collection-item', class: 'sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            { path: '/superadmin/analysislist', title: 'All Analysis', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], accessPermission: ['get_user'], childpath: '' },
            { path: '/superadmin/imagelocation', title: 'Image Location', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], accessPermission: ['get_user'], childpath: '' },
        ], accessPermission: ['create_customer'], childpath: ''
    },
    {
        path: '', title: 'Scan List', icon: 'zmdi zmdi-collection-item', class: 'sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: [

            { path: '/superadmin/scanlist', title: 'All Scans', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], accessPermission: ['get_customer'], childpath: '' },
        ], accessPermission: ['get_customer'], deninedPermission: ['get_admin'], childpath: ''
    },

    {
        path: '', title: 'User Management', icon: 'zmdi zmdi-group-work', class: 'sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
                path: '/superadmin/users',
                title: 'All Users',
                icon: 'fa fa-dot-circle-o',
                class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], accessPermission: ['get_user'], childpath: '' },
        ], accessPermission: ['create_customer'], childpath: ''
    }
    ,
    {
        path: '', title: 'Store Management', icon: 'zmdi zmdi-toys', class: 'sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
                path: '/storemanagement/installationcenters',
                title: 'Installation Centers',
                icon: 'fa fa-dot-circle-o',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: [],
                accessPermission: ['get_installation'],
                childpath: ''
            }
        ],
        accessPermission: ['create_customer'],
        childpath: '/storemanagement/installationcenters'
    },

    {
        path: '', title: 'Device Management', icon: 'zmdi zmdi-library', class: 'sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            { path: '/inventory/devices', title: 'Devices', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], accessPermission: ['create_inventory'], childpath: '' },
            { path: '/inventory/provision', title: 'Provisions', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], accessPermission: ['device_provisioning'], childpath: '' },
            { path: '/inventory/device-license', title: 'Licenses', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], accessPermission: ['device_provisioning'], childpath: '' },
            { path: '/inventory/update-location', title: 'Update Lat and Long', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], accessPermission: ['device_provisioning'], childpath: '' },
        ], accessPermission: ['create_customer'], childpath: ''
    },
    ,
    {
        path: '/scanfilter/singlescans', title: 'Scan Filter', icon: 'zmdi zmdi-filter-list', class: 'sub', badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
           // { path: '/scanfilter/duplicatescans', title: 'Duplicate Scans', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], accessPermission: ['edit_scan_details'], childpath: '' },
            { path: '/scanfilter/singlescans', title: 'Search Scans', icon: 'fa fa-dot-circle-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [], accessPermission: ['edit_scan'], childpath: '' },
            
        ], 
        //accessPermission: ['edit_scan_details'], childpath: ''
        accessPermission: ['edit_scan'], childpath: ''
    }
    ,
    {
        path: '/dashboard/analytics',
        title: 'Analytics',
        icon: 'zmdi zmdi-chart',
        class: 'sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        accessPermission: ['customer_admin', 'CUSTOMER'],
        childpath: '/dashboard/analytics'
    },
    {
        path: '/dashboard/grafana',
        title: 'Dashboard',
        icon: 'zmdi zmdi-chart',
        class: 'sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        accessPermission: ['customer_admin', 'CUSTOMER', 'create_installation'],
        childpath: '/dashboard/grafana'
    },
    {
        path: '/dashboard/tea-analysis',
        title: 'Tea Analysis',
        icon: 'zmdi zmdi-chart-donut',
        class: 'sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [],
        accessPermission: ['customer_admin', 'CUSTOMER'],
        childpath: '/dashboard/tea-analysis'
    },
    {
        path: '',
        title: 'Supplier Management',
        icon: 'zmdi zmdi-account-box',
        class: 'sub',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: [
            {
                path: '/dashboard/supplier-details',
                title: 'Supplier Details',
                icon: 'fa fa-dot-circle-o',
                class: '',
                badge: '',
                badgeClass: '',
                isExternalLink: false,
                submenu: [],
                accessPermission: ['create_customer'],
                childpath: ''
            }
        ],
        accessPermission: ['create_customer'],
        childpath: ''
    },

    
    
];
